// extracted by mini-css-extract-plugin
module.exports = {"commentHeader":"f_Dek","search":"_68z9r","commentTime":"_11D48","withMoreButton":"_3LpVq","moreButton":"_2Fp08"};